import { createContext, useContext } from 'react';

export type BrokerageNavId = 'main' | 'sub' | 'wallet' | 'settings';

const StaggerKeyContext = createContext<BrokerageNavId | null>(null);

export function StaggerKeyProvider({
  value,
  children,
}: {
  value: BrokerageNavId;
  children: React.ReactNode;
}) {
  return (
    <StaggerKeyContext.Provider value={value}>
      {children}
    </StaggerKeyContext.Provider>
  );
}

/**
 * Use this as the key for list/table stagger containers.
 * Stagger runs only when this key changes (e.g. switching Main / Sub / Wallet).
 * Sort/filter on the same page keeps the same key, so stagger does not re-trigger.
 */
export function useStaggerKey(): BrokerageNavId | null {
  return useContext(StaggerKeyContext);
}
